import {useSelector} from 'react-redux';


import * as cartSelectors from '../cartSelectors';


/**
 * @return {string} Active cart id
 */
function useActiveCartId() {

    return useSelector(cartSelectors.getActiveCartId);
}


export default useActiveCartId;
